import React, { FunctionComponent } from "react";
import NumberComponent, { NumberComponentProps } from "./NumberComponent";
import { VALUE_TYPE } from "c8-platform";
import { DEFAULT_DECIMAL_FORMAT } from "csi/utility/numberUtility";

const DoubleComponent: FunctionComponent<NumberComponentProps> = (
	{
		valueType,
		...otherProps
	},
) => (
	<NumberComponent
		{...otherProps}
		format={otherProps.format || DEFAULT_DECIMAL_FORMAT}
		valueType={VALUE_TYPE.DOUBLE}
	/>
);

export default DoubleComponent;
